module.exports = __webpack_public_path__ + "img/mstile-144x144.89d59ebe.png";